import {Helmet} from 'react-helmet';

function Cplusplus() {
    return (
        <div className="IDE" data-pym-src="https://www.jdoodle.com/embed/v0/49nR?&arg=0">
             <Helmet>
             <script src="https://www.jdoodle.com/assets/jdoodle-pym.min.js" type="text/javascript"></script>   
             </Helmet>
        </div>
    );
}

export default Cplusplus;
